// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const V1StoreFormatConfig = {
  StoreFormatBlock: 'block',
  StoreFormatStandard: 'record',
  StoreFormatAligned: 'aligned',
  StoreFormatHighlimit: 'high_limit',
} as const;
export type V1StoreFormatConfig =
  (typeof V1StoreFormatConfig)[keyof typeof V1StoreFormatConfig];

export function instanceOfV1StoreFormatConfig(value: any): boolean {
  for (const key in V1StoreFormatConfig) {
    if (Object.prototype.hasOwnProperty.call(V1StoreFormatConfig, key)) {
      if (
        V1StoreFormatConfig[key as keyof typeof V1StoreFormatConfig] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function V1StoreFormatConfigFromJSON(json: any): V1StoreFormatConfig {
  return V1StoreFormatConfigFromJSONTyped(json, false);
}

export function V1StoreFormatConfigFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1StoreFormatConfig {
  return json as V1StoreFormatConfig;
}

export function V1StoreFormatConfigToJSON(
  value?: V1StoreFormatConfig | null,
): any {
  return value as any;
}

export function V1StoreFormatConfigToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): V1StoreFormatConfig {
  return value as V1StoreFormatConfig;
}
